"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Loader;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _index = _interopRequireDefault(require("@site/pattern-library/elements/other/spinner/index.js"));
const LoadingContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "LoadingContainer",
  class: "pc-lxgpku6"
});
function Loader() {
  return /*#__PURE__*/_react.default.createElement(LoadingContainer, null, /*#__PURE__*/_react.default.createElement(_index.default, {
    size: "lg",
    centerHorizontally: true
  }));
}